import type { EnergyTypes } from '~/types/new/energy';
import type { StandardTypes } from '../../types';

export const standardRepository = () => {
  const { client } = useApiV2();
  const { cancelRequestIfDoubled } = useCoreApiHelper();

  // Store
  const { standardError, loading, standardResponse } = storeToRefs(standardStore());

  const getStandard = async (options: {
    energyType: EnergyTypes;
    start: string;
    end: string;
    standardType: StandardTypes;
    areaId: number;
  }) => {
    await cancelRequestIfDoubled({
      requestId: 'standard-details',
      execute: async (signal) =>
        client.GET('/v2/areas/{area_id}/standard/details', {
          params: {
            query: {
              energy_type: options.energyType,
              start: options.start,
              end: options.end,
              standard_type: options.standardType,
            },
            path: {
              area_id: options.areaId,
            },
          },
          signal: signal,
        }),
      onLoadingStart: () => {
        loading.value = true;
      },
      onLoadingEnd: () => {
        loading.value = false;
      },
      onError: (error) => {
        standardError.value = error;
      },
      onSuccess: (data) => {
        standardResponse.value = data;
        standardError.value = null;
      },
    });
  };

  return { getStandard };
};
